import { chakra } from '@plurall/elo-v3';

import {
  actionsRecipe,
  containerRecipe,
  detailsRecipe,
  errorBlockRecipe,
  errorContentRecipe,
  messageRecipe,
  rootRecipe,
  summaryRecipe,
  titleRecipe,
} from './errorBoundary.recipe';

export const ErrorBoundaryRootFactory = chakra('div', rootRecipe);
export const ErrorBoundaryContainerFactory = chakra('div', containerRecipe);
export const ErrorBoundaryTitleFactory = chakra('h1', titleRecipe);
export const ErrorBoundaryMessageFactory = chakra('p', messageRecipe);
export const ErrorBoundaryDetailsFactory = chakra('details', detailsRecipe);
export const ErrorBoundarySummaryFactory = chakra('summary', summaryRecipe);
export const ErrorBoundaryErrorContentFactory = chakra('div', errorContentRecipe);
export const ErrorBoundaryErrorBlockFactory = chakra('div', errorBlockRecipe);
export const ErrorBoundaryActionsFactory = chakra('div', actionsRecipe);
